import { render, staticRenderFns } from "./HomeFAQ.vue?vue&type=template&id=013b363c&scoped=true&"
import script from "./HomeFAQ.vue?vue&type=script&lang=js&"
export * from "./HomeFAQ.vue?vue&type=script&lang=js&"
import style0 from "./HomeFAQ.vue?vue&type=style&index=0&id=013b363c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013b363c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer,VRow})
